export default __webpack_public_path__ + "static/Plots0019-8b49b9aa487f9c5e54d58cc0335ecbd9.jpg";